module.exports = __webpack_public_path__ + "img/소드마스터.c7833317.png";